import { CreateEditBatchItemBody } from '$modules/personal/modules/batch/features/batches/models';

export function adaptObject(source): CreateEditBatchItemBody {
  const original: CreateEditBatchItemBody = {
    recipient_contact_widget_data: null,
    s10code: '',
    notification_s10code: '',
    notification: '0',
    weight: null,
    addons: {
      phone: null,
      email: null,
      shelf_life: null,
      declared_value: null,
      cash_on_delivery: null,
      careful_fragile: null,
      hand_over_personally: null,
      subpoena: null,
      service: null,
      government: null,
      military: null,
      description: null,
      bulky: null,
      recipient_payment: null,
      partial_return: null,
      documents_return: null,
      deliver_to_work: null,
      open_upon_delivery: null,
      time_of_delivery: null,
      free_return: null,
      notification: null,
      coordinate_delivery_interval: null,
    },
  };

  for (const key in source) {
    if (original.hasOwnProperty(key)) {
      original[key] = source[key];
    } else if (original.addons.hasOwnProperty(key)) {
      original.addons[key] = source[key];
    } else if (key === 'recipient') {
      original.recipient_contact_widget_data = source[key];
    }
  }

  return original;
}
